/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_MenuInputs */

const en_new_menu = /** @type {(inputs: New_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New menu`)
};

const fr_new_menu = /** @type {(inputs: New_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu nouveau`)
};

const de_new_menu = /** @type {(inputs: New_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Menü`)
};

const it_new_menu = /** @type {(inputs: New_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo menu`)
};

const ru_new_menu = /** @type {(inputs: New_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новое меню`)
};

const es_new_menu = /** @type {(inputs: New_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo menú`)
};

const zh_cn2_new_menu = /** @type {(inputs: New_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新菜单`)
};

const ja_new_menu = /** @type {(inputs: New_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新メニュー`)
};

const hi_new_menu = /** @type {(inputs: New_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया मेनू`)
};

const pt_pt2_new_menu = /** @type {(inputs: New_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo menu`)
};

/**
* | output |
* | --- |
* | "New menu" |
*
* @param {New_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_menu = /** @type {((inputs?: New_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_menu(inputs)
	if (locale === "de") return de_new_menu(inputs)
	if (locale === "it") return it_new_menu(inputs)
	if (locale === "ru") return ru_new_menu(inputs)
	if (locale === "es") return es_new_menu(inputs)
	if (locale === "zh-CN") return zh_cn2_new_menu(inputs)
	if (locale === "ja") return ja_new_menu(inputs)
	if (locale === "hi") return hi_new_menu(inputs)
	if (locale === "pt-PT") return pt_pt2_new_menu(inputs)
	return en_new_menu(inputs)
});